import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Title } from "@angular/platform-browser";
import { FormsModule } from '@angular/forms';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { AppLayoutModule } from './layout/app.layout.module';

import { Observable, of, from, map, filter, tap, concatMap, catchError, throwError } from "rxjs";

import { FileUploadModule } from 'primeng/fileupload';

// import { AuthModule, AuthGuard } from '@auth0/auth0-angular';
// import { AuthService, AuthGuardService } from './shared/auth.service'

/*
 * 20210904
 * 
 * https://www.npmjs.com/package/keycloak-angular#installation
 * 
 */
import { APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RippleModule } from 'primeng/ripple';

import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { AuthGuard } from 'src/app/shared/auth.service'

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';

import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { TabViewModule } from 'primeng/tabview';
import { ToolbarModule } from 'primeng/toolbar';
import { DialogModule } from 'primeng/dialog';
import { TreeModule } from 'primeng/tree';
import { CalendarModule } from 'primeng/calendar';
import { TooltipModule } from 'primeng/tooltip';

import { ContextMenuModule } from 'primeng/contextmenu';
import { ProgressBarModule } from 'primeng/progressbar';

import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { AccordionModule } from 'primeng/accordion';
import { ChartModule } from 'primeng/chart';
import { SliderModule } from 'primeng/slider';
import { SplitterModule } from 'primeng/splitter';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TagModule } from 'primeng/tag';
import { SplitButtonModule } from 'primeng/splitbutton';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FieldsetModule } from 'primeng/fieldset';
import { EditorModule } from 'primeng/editor';
import { BlockUIModule } from 'primeng/blockui';
import { MenubarModule } from 'primeng/menubar';
import { TabMenuModule } from 'primeng/tabmenu';
import { ScrollTopModule } from 'primeng/scrolltop';

import { environment } from '../environments/environment';

import { GetglobalsettingsService } from './services/getglobalsettings.service';
import { AppConfig, AppConfigService } from './services/AppConfigService';
import { SecureApiService } from './services/secure-api.service';
import { RestApiService } from './services/rest-api.service';
import { ClientApiService } from './services/client-api.service';
import { DocumentApiService } from './services/document-api.service';
import { ProductApiService } from './services/product-api.service';
import { HelperServerApiServiceService } from './services/helper-server-api-service.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { ListboxModule } from 'primeng/listbox';
import { GlobalSettingsComponent } from './global-settings/global-settings.component';
// import { ToolbarComponent } from './toolbar/toolbar.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { DocumentsComponent } from './documents/documents.component';
import { ClientsComponent } from './clients/clients.component';
import { PersonsComponent } from './persons/persons.component';
import { AgentDashboardComponent } from './agent-dashboard/agent-dashboard.component';
import { AgentSpamQueueComponent } from './agent-spam-queue/agent-spam-queue.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { CurrencyselectorComponent } from './visualcomponents/currencyselector/currencyselector.component';
import { CompanyselectorComponent } from './visualcomponents/companyselector/companyselector.component';
import { PersonselectorComponent } from './visualcomponents/personselector/personselector.component';
import { DocumentselectorComponent } from './visualcomponents/documentselector/documentselector.component';
import { PipeTrimStr, PipeselecteditemsPipe } from './shared/pipeselecteditems.pipe';
import { StopAccordionHomeEndDirective } from './shared/stop-accordion-home-end.directive';
import { SetupComponent } from './setup/setup.component';
import { DepartmentselectorComponent } from './visualcomponents/departmentselector/departmentselector.component';
import { EditCurrencyDlgComponent } from './dialogs/edit-currency-dlg/edit-currency-dlg.component';
import { AgentBankPaymentReviewComponent } from './dialogs/agent-bank-payment-review/agent-bank-payment-review.component';
import { AgentBankPaymentSplitComponent } from './dialogs/agent-bank-payment-split/agent-bank-payment-split.component';
import { DocumentPreflightComponent } from './dialogs/document-preflight/document-preflight.component';
import { DocumentPreflightSummaryComponent } from './dialogs/document-preflight/document-preflight-summary.component';
import { CurrencyRatesComponent } from './currency-rates/currency-rates.component';
import { EditDocumentComponent } from './edit-document/edit-document.component';
import { DocumentsTreeComponent } from './dialogs/documents-tree/documents-tree.component';
import { ProductsComponent } from './products/products.component';
import { EditProductComponent } from './edit-product/edit-product.component';
import { SalesLeadsComponent } from './sales-leads/sales-leads.component';
import { ProdgroupselectorComponent } from './visualcomponents/prodgroupselector/prodgroupselector.component';
import { ProductselectorComponent } from './visualcomponents/productselector/productselector.component';
import { TabTitleDirective } from './directives/tab-title.directive';
import { DocumentsSearchComponent } from './dialogs/documents-search/documents-search.component';
import { ProductsSearchComponent } from './dialogs/products-search/products-search.component';
import { ClientsSearchComponent } from './dialogs/clients-search/clients-search.component';
import { ProdgroupSearchComponent } from './dialogs/prodgroup-search/prodgroup-search.component';
import { EditClientComponent } from './edit-client/edit-client.component';
import { CustomercategoryselectorComponent } from './visualcomponents/customercategoryselector/customercategoryselector.component';
import { EditUserAccessComponent } from './edit-user-access/edit-user-access.component';
import { AgentSetupComponent } from './agent-setup/agent-setup.component';
import { HiddenDocumentsComponent } from './hidden-documents/hidden-documents.component';
import { EditVariableComponent } from './edit-variable/edit-variable.component';
import { DocumentContentTableComponent } from './visualcomponents/document-content-table/document-content-table.component';
import { ItemTurnoverSheetComponent } from './reports/item-turnover-sheet/item-turnover-sheet.component';
import { TurnoverSheetTableComponent } from './visualcomponents/turnover-sheet-table/turnover-sheet-table.component';
import { ProductListComponent } from './visualcomponents/product-list/product-list.component';
import { ProdGroupTreeComponent } from './visualcomponents/prod-group-tree/prod-group-tree.component';
import { Products2Component } from './products2/products2.component';
import { ProductInfoComponent } from './visualcomponents/product-info/product-info.component';
import { VariableSelectorComponent } from './visualcomponents/variable-selector/variable-selector.component';
import { VariableEditComponent } from './dialogs/variable-edit/variable-edit.component';
import { EditProductVendorsComponent } from './visualcomponents/edit-product-vendors/edit-product-vendors.component';
import { EditProductPartsComponent } from './visualcomponents/edit-product-parts/edit-product-parts.component';
import { SecurityGroupSelectorComponent } from './visualcomponents/security-group-selector/security-group-selector.component';
import { CreateNewDocumentComponent } from './dialogs/create-new-document/create-new-document.component';
import { ConfirmDeleteProductPartComponent } from './dialogs/confirm-delete-product-part/confirm-delete-product-part.component';
import { EditDocumentContentComponent } from './visualcomponents/edit-document-content/edit-document-content.component';
import { DocumentTransactionTableComponent } from './visualcomponents/document-transaction-table/document-transaction-table.component';
import { DocumentSalesResultTableComponent } from './visualcomponents/document-sales-result-table/document-sales-result-table.component';
import { ProductListPaidComponent } from './visualcomponents/product-list-paid/product-list-paid.component';
import { ProductListInvoicedComponent } from './visualcomponents/product-list-invoiced/product-list-invoiced.component';
import { ProductReservationTableComponent } from './visualcomponents/product-reservation-table/product-reservation-table.component';
import { ExportDocumentComponent } from './dialogs/export-document/export-document.component';
import { ProductPriceHistoryComponent } from './visualcomponents/product-price-history/product-price-history.component';
import { PendingChangesGuard } from 'src/app/shared/pending-changes.guard';
import { CompanySearchComponent } from './visualcomponents/company-search/company-search.component';
import { NewDocumentDlgDatesComponent } from './visualcomponents/new-document-dlg-dates/new-document-dlg-dates.component';
import { NewDocumentDlgCompaniesComponent } from './visualcomponents/new-document-dlg-companies/new-document-dlg-companies.component';
import { NewDocumentDlgConditionsComponent } from './visualcomponents/new-document-dlg-conditions/new-document-dlg-conditions.component';
import { NewDocumentDlgProcessPaymentComponent } from './visualcomponents/new-document-dlg-process-payment/new-document-dlg-process-payment.component';
import { NewDocumentDlgDocItemsComponent } from './visualcomponents/new-document-dlg-doc-items/new-document-dlg-doc-items.component';
import { NewDocumentDlgAiAssistComponent } from './visualcomponents/new-document-dlg-ai-assist/new-document-dlg-ai-assist.component';
import { EditDocumentCompanyComponent } from './visualcomponents/edit-document-company/edit-document-company.component';
import { EditDocumentClientComponent } from './visualcomponents/edit-document-client/edit-document-client.component';
import { EditDocumentConditionsComponent } from './visualcomponents/edit-document-conditions/edit-document-conditions.component';
import { NewDocumentDlgProcessInvoiceComponent } from './visualcomponents/new-document-dlg-process-invoice/new-document-dlg-process-invoice.component';
import { RenameSomethingDialogComponent } from './dialogs/rename-something-dialog/rename-something-dialog.component';
import { ListClientPersonsComponent } from './visualcomponents/list-client-persons/list-client-persons.component';
import { ListClientLcosComponent } from './visualcomponents/list-client-lcos/list-client-lcos.component';
import { EditClientDepartmentsComponent } from './visualcomponents/edit-client-departments/edit-client-departments.component';
import { EditPersonComponent } from './edit-person/edit-person.component';
import { ImportExcelDlgComponent } from './dialogs/import-excel-dlg/import-excel-dlg.component';
import { ListDocItemsComponent } from './visualcomponents/list-doc-items/list-doc-items.component';
import { ReportProductTosComponent } from './report-product-tos/report-product-tos.component';
import { EditDocumentPoComponent } from './edit-document-po/edit-document-po.component';
import { EditDocumentSpecComponent } from './edit-document-spec/edit-document-spec.component';
import { EditDocumentContentSpecComponent } from './visualcomponents/edit-document-content-spec/edit-document-content-spec.component';
import { EditDocumentContentPoComponent } from './visualcomponents/edit-document-content-po/edit-document-content-po.component';
import { NewDocumentDlgProcessPoComponent } from './visualcomponents/new-document-dlg-process-po/new-document-dlg-process-po.component';
import { EditPrintReportsComponent } from './visualcomponents/edit-print-reports/edit-print-reports.component';
import { ProductListInTransitComponent } from './visualcomponents/product-list-in-transit/product-list-in-transit.component';
import { EditDocumentReceiptComponent } from './edit-document-receipt/edit-document-receipt.component';
import { EditDocumentContentReceiptComponent } from './visualcomponents/edit-document-content-receipt/edit-document-content-receipt.component';
import { EditDocumentConditionsReceiptComponent } from './visualcomponents/edit-document-conditions-receipt/edit-document-conditions-receipt.component';
import { NewDocumentDlgProcessReceiptComponent } from './visualcomponents/new-document-dlg-process-receipt/new-document-dlg-process-receipt.component';
import { NewDocumentDlgProcessShipmentComponent } from './visualcomponents/new-document-dlg-process-shipment/new-document-dlg-process-shipment.component';
import { NewDocumentDlgCompaniesReceiptComponent } from './visualcomponents/new-document-dlg-companies-receipt/new-document-dlg-companies-receipt.component';
import { NewDocumentDlgConditionsReceiptComponent } from './visualcomponents/new-document-dlg-conditions-receipt/new-document-dlg-conditions-receipt.component';
import { NewDocumentDlgProcessSpecComponent } from './visualcomponents/new-document-dlg-process-spec/new-document-dlg-process-spec.component';
import { NewDocumentDlgProcessTransactionComponent } from './visualcomponents/new-document-dlg-process-transaction/new-document-dlg-process-transaction.component';
import { HomeRecentOrdersListComponent } from './visualcomponents/home-recent-orders-list/home-recent-orders-list.component';
import { DocumentListTableComponent } from './visualcomponents/document-list-table/document-list-table.component';
import { HomePaidOrdersListComponent } from './visualcomponents/home-paid-orders-list/home-paid-orders-list.component';
import { HomeNotShippedOrdersListComponent } from './visualcomponents/home-not-shipped-orders-list/home-not-shipped-orders-list.component';
import { HomeNotPaidOrdersListComponent } from './visualcomponents/home-not-paid-orders-list/home-not-paid-orders-list.component';
import { HomeActiveOrdersListComponent } from './visualcomponents/home-active-orders-list/home-active-orders-list.component';
import { HomeChartCurrencyRatesComponent } from './visualcomponents/home-chart-currency-rates/home-chart-currency-rates.component';
import { HomeChartAnnualSalesComponent } from './visualcomponents/home-chart-annual-sales/home-chart-annual-sales.component';
import { HomeChartPerformanceSalesComponent } from './visualcomponents/home-chart-performance-sales/home-chart-performance-sales.component'
import { NewDocumentDlgProcessTranImpComponent } from './visualcomponents/new-document-dlg-process-tran-imp/new-document-dlg-process-tran-imp.component';
import { NewDocumentDlgProcessTranProdComponent } from './visualcomponents/new-document-dlg-process-tran-prod/new-document-dlg-process-tran-prod.component';
import { NewDocumentDlgProcessTranMoveComponent } from './visualcomponents/new-document-dlg-process-tran-move/new-document-dlg-process-tran-move.component';
import { NewDocumentDlgProcessTranSaleComponent } from './visualcomponents/new-document-dlg-process-tran-sale/new-document-dlg-process-tran-sale.component';
import { EditDocumentContentPaymentComponent } from './visualcomponents/edit-document-content-payment/edit-document-content-payment.component';
import { ProductListStocksComponent } from './visualcomponents/product-list-stocks/product-list-stocks.component';
import { EditSalesLeadComponent } from './edit-sales-lead/edit-sales-lead.component';
import { ListSalesLeadItemsComponent } from './visualcomponents/list-sales-lead-items/list-sales-lead-items.component';
import { EditSalesLeadItemsComponent } from './visualcomponents/edit-sales-lead-items/edit-sales-lead-items.component';
import { ProductPartListPaidComponent } from './visualcomponents/product-part-list-paid/product-part-list-paid.component';
import { ListManufacturingStatusComponent } from './visualcomponents/list-manufacturing-status/list-manufacturing-status.component';
import { EditDocumentRowInfoComponent } from './visualcomponents/edit-document-row-info/edit-document-row-info.component';
import { ProductPartListByDocComponent } from './visualcomponents/product-part-list-by-doc/product-part-list-by-doc.component';
import { EditDocumentInventoryComponent } from './edit-document-inventory/edit-document-inventory.component';
import { EditDocumentContentInventoryComponent } from './visualcomponents/edit-document-content-inventory/edit-document-content-inventory.component';
import { EditDocumentCompanyInventoryComponent } from './visualcomponents/edit-document-company-inventory/edit-document-company-inventory.component';
import { EditDocumentClientInventoryComponent } from './visualcomponents/edit-document-client-inventory/edit-document-client-inventory.component';
import { NewDocumentDlgCompaniesInventoryComponent } from './visualcomponents/new-document-dlg-companies-inventory/new-document-dlg-companies-inventory.component';
import { NewDocumentDlgClientInventoryComponent } from './visualcomponents/new-document-dlg-client-inventory/new-document-dlg-client-inventory.component';
import { EditDocTypeItemComponent } from './visualcomponents/edit-doc-type-item/edit-doc-type-item.component';
import { EditDocTypesComponent } from './visualcomponents/edit-doc-types/edit-doc-types.component';
import { CreatePriceListComponent } from './reports/create-price-list/create-price-list.component';
import { ListProductArrayComponent } from './visualcomponents/list-product-array/list-product-array.component';
import { ListDocumentPaymentsComponent } from './visualcomponents/list-document-payments/list-document-payments.component';
import { ImportProductInfoDlgComponent } from './dialogs/import-product-info-dlg/import-product-info-dlg.component';
import { ListCurrencyRatesComponent } from './visualcomponents/list-currency-rates/list-currency-rates.component';
import { UpdateCurrencyByExternalApiComponent } from './visualcomponents/update-currency-by-external-api/update-currency-by-external-api.component';
import { CompanyRegisterVerifyComponent } from './visualcomponents/company-register-verify/company-register-verify.component';
import { CompanyDirectorQuickSetComponent } from './visualcomponents/company-director-quick-set/company-director-quick-set.component';
import { AgentCustomerQuickCreateComponent } from './visualcomponents/agent-customer-quick-create/agent-customer-quick-create.component';
import { AgentCustomerUpdateOfferComponent } from './visualcomponents/agent-customer-update-offer/agent-customer-update-offer.component';
import { AgentPasteToCreateComponent } from './visualcomponents/agent-paste-to-create/agent-paste-to-create.component';
import { CustomerBusinessAreaSelectorComponent } from './visualcomponents/customer-business-area-selector/customer-business-area-selector.component';
import { ProductGlobalCategorySelectorComponent } from './visualcomponents/product-global-category-selector/product-global-category-selector.component';
import { ListClientBalanceDueComponent } from './visualcomponents/list-client-balance-due/list-client-balance-due.component';
import { ListDocumentsForClientComponent } from './visualcomponents/list-documents-for-client/list-documents-for-client.component';
import { ListDocumentsForProductComponent } from './visualcomponents/list-documents-for-product/list-documents-for-product.component';
import { ProductSerialsTableComponent } from './visualcomponents/product-serials-table/product-serials-table.component';
import { ListProductsParentComponent } from './visualcomponents/list-products-parent/list-products-parent.component';
import { SelectProductCategoryComponent } from './dialogs/select-product-category/select-product-category.component';
import { ListDocumentWarningsComponent } from './visualcomponents/list-document-warnings/list-document-warnings.component';
import { KeycloakuserselectorComponent } from './visualcomponents/keycloakuserselector/keycloakuserselector.component';

import { NewDocumentDlgProcessTranInterComponent } from './visualcomponents/new-document-dlg-process-tran-inter/new-document-dlg-process-tran-inter.component';
import { CopyDepartmentsComponent } from './dialogs/copy-departments/copy-departments.component';
import { ShowDepartmentNameComponent } from './visualcomponents/show-department-name/show-department-name.component';
import { EditUserAccessTabComponent } from "./visualcomponents/edit-user-access-tab/edit-user-access-tab.component";
import { EditAccessGroupsTabComponent } from "./visualcomponents/edit-access-groups-tab/edit-access-groups-tab.component";
import { ListProductsOfCustomerComponent } from './visualcomponents/list-products-of-customer/list-products-of-customer.component'; 
import { ListProductsCustomersTransactionsComponent } from './visualcomponents/list-products-customers-transactions/list-products-customers-transactions.component';
import { HomeChartDailyPaymentsComponent } from './visualcomponents/home-chart-daily-payments/home-chart-daily-payments.component'; 
import { HomeChartMonthlyPaymentsComponent } from './visualcomponents/home-chart-monthly-payments/home-chart-monthly-payments.component'; 
import { HomeChartMonthlyClientPaymentsComponent } from './visualcomponents/home-chart-monthly-client-payments/home-chart-monthly-client-payments.component';
import { EditAgentTeamMembersTabComponent } from './visualcomponents/edit-agent-team-members-tab/edit-agent-team-members-tab.component';
import { EditAgentBankCredentialsTabComponent } from './visualcomponents/edit-agent-bank-credentials-tab/edit-agent-bank-credentials-tab.component';
import { EditAgentBankBlockedCounterpartiesTabComponent } from './visualcomponents/edit-agent-bank-blocked-counterparties-tab/edit-agent-bank-blocked-counterparties-tab.component';
import { EditAgentCustomerTierTabComponent } from './visualcomponents/edit-agent-customer-tier-tab/edit-agent-customer-tier-tab.component';
import { EditAgentCustomerTierListTabComponent } from './visualcomponents/edit-agent-customer-tier-list-tab/edit-agent-customer-tier-list-tab.component';
import { EditPriceVariablesTabComponent } from './visualcomponents/edit-price-variables-tab/edit-price-variables-tab.component';
import { IncomePriceBreakdownDialogComponent } from './visualcomponents/income-price-breakdown-dialog/income-price-breakdown-dialog.component';
import { ManufacturingBackdocPriceCheckDialogComponent } from './visualcomponents/manufacturing-backdoc-price-check-dialog/manufacturing-backdoc-price-check-dialog.component';

function initialConfigurationLoad(globalSettingsService: GetglobalsettingsService, appConfig: AppConfigService, keycloak: KeycloakService): () => Observable<any> {

  // Here the main initializasion sequence starts.
  //
  // We need 1) link to authentication and authorisazion server, as well as link to 2) sql and 3) api server
  //
  //  User configuration went from user login (key from AA server) and should be found in database
  //
  //  Unexpected bonus/trick with Keycloak.
  // Having two portal (one matured for stable work and another one for development) we have also two different keycloak servers
  // Adding new user to two different server is a bit tricky - user Id used for customer identification could not be copied from between the servers.
  // So, we have to use different user Ids for different servers.
  //
  //  Another option out of current scope is automated synchronization of user Ids between two keycloak servers.
  //
  //  This sequence nonambiguity defines main company and user
  //  Rest will be pulled from database/user setings
  //
  return () => globalSettingsService.getObservableDefaultConnSettings().pipe(

    //
    // Connection's options from local storage (defined in environment during building process)
    //
    tap(ret => {
      environment.production || console.log('***  [AppModule] (once been environment, now app.config.json) ---------------------->>>>>>>>>>>>>>>>>>>>>>>>: ' + JSON.stringify(ret, null, 2));
    }),
    catchError(error => {
      console.error('[AppModule] Failed to load default connection settings:', error);
      return throwError(() => new Error('[AppModule] Failed to load default connection settings: ' + error.message));
    }),

    // By fact this procedure pulls configuration from /assets/app.config.json file

    concatMap(() => appConfig.loadInitialConnectionConfiguration().pipe(
      catchError(error => {
        console.error('[AppModule] Failed to load initial connection configuration:', error);
        return throwError(() => new Error('[AppModule] Failed to load initial connection configuration: ' + error.message));
      })
    )),

    //
    // Connection's options from app bootstrap initial directory (defined in app.config.json during deployment process)
    // Link defined in environment
    //
    // By fact we are doing the same - pulling configuration from /assets/app.config.json file or cached configuration
    //
    concatMap(() => appConfig.getObservableConfigNew().pipe(
      tap(conf => environment.production || console.log('*** [AppModule] (deployment) ---------------------->>>>>>>>>>>>>>>>>>>>>>>>: ' + JSON.stringify(conf, null, 2))),

      map(conf => ({
        realm: conf.connection.authServer.realm,
        url: conf.connection.authServer.url,
        clientId: conf.connection.authServer.clientId,
      })),

      // Anyway link to AA server get directly from deployment server
      // Without app.config.json there is no sense to continue bootup process (???)
      // However, we could use hardcoded environment variables,
      // but missing the app.config.json looks like incorrect deployment

      concatMap(fe => from(keycloak.init({
        config: fe,  // portal, user id and url
        initOptions: {
          onLoad: 'login-required',
          checkLoginIframe: false,
          silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
        },
        bearerExcludedUrls: ['https://bank.gov.ua/', 'https://api.erc.ua/', 'https://connect.erc.ua/'],
      })).pipe(
        tap(authenticated => {
          if (!authenticated) {
            console.error('[AppModule] Authentication failed');
            throw new Error('[AppModule] Failed to authenticate with Keycloak');
          }
          environment.production || console.log('[AppModule] Successfully authenticated with Keycloak');
        }),

        // Handle any errors during initialization
        catchError(error => {
          console.error('[AppModule] Keycloak initialization error:', error);
          return throwError(() => new Error('[AppModule] Keycloak initialization error: ' + error.message));
        })
      )),

      catchError(error => {
        console.error('[AppModule] Failed to get config or initialize Keycloak:', error);
        return throwError(() => new Error('[AppModule] Failed to get config or initialize Keycloak: ' + error.message));
      })
    )),

    // From this point we are authenticated and have access to the user profile
    // this.auth.user$ is an observable that contains user profile information
    // We can use it to get user information like access group, main person and company, departments, currencies etc.

    // To access this information simply add to constructor public auth: KeycloakService
    // and use it like this.auth.user$ to get user profile information

    // Below we are pulling connection's parameters stored in cookies
    // In theory during the work user could change something in connection's parameters
    // Like database server, API or report servers.
    // Definitely it is impossible to change the authentication server

    // Here we need to reread connection's parameters from app.config.json and
    // update them with some user specific settings from cookies / local storage

    concatMap(() => globalSettingsService.getObservableLocalConnSettings().pipe(
      concatMap(conn => appConfig.getObservableConfigNew().pipe(

        // conn here is the connection parameters saved in the local app store
        // conf is the connection parameters pulled from app.config.json file
        // In genereal local storage doesn't matters anymore, but some still can be used to override app.config.json settings

        // But at the end we se`e the merged connection's settings for authserver instead of from app.config.json only

        tap(() => environment.production || console.log('*** [AppModule] (connection) ---------------------->>>>>>>>>>>>>>>>>>>>>>>>: ' + JSON.stringify(conn, null, 2))),
        tap(conf => environment.production || console.log('*** [AppModule] (loaded) ---------------------->>>>>>>>>>>>>>>>>>>>>>>>: ' + JSON.stringify(conf, null, 2))),

        map(conf => {
          // merge connection settings leaving the authServer settings from app.config.json
          return {
            ...conf.connection,
            ...conn,
            authServer: conf.connection.authServer
          };
        }),
        
        tap(merged => environment.production || console.log('*** [AppModule] (merged) ---------------------->>>>>>>>>>>>>>>>>>>>>>>>: ' + JSON.stringify(merged, null, 2))),
        
        map(merged => globalSettingsService.setConnSettings(merged

        // Here we are merging connection's parameters from app.config.json and globalSettingsService
        // This is the main connection's parameters used by the application
        // Current conn implementation does not use anymore, because pulled old connection settings from local storage
        // In new connection settings all parameters moved to particular server section
        // See the connection settings in environment.ts file
        )),
      )),

      catchError(error => {
        console.error('[AppModule] Failed to merge connection settings:', error);
        return throwError(() => new Error('[AppModule] Failed to merge connection settings: ' + error.message));
      })
    )),

    // Ensure we return a value for successful completion
    map(() => true),
    catchError(error => {
      console.error('[AppModule] Application initialization failed:', error);
      return throwError(() => new Error('[AppModule] Application initialization failed: ' + error.message));
    })
  );
}

  @NgModule({
    declarations: [
      AppComponent,
      FooterComponent,
      HomeComponent,
      DocumentsComponent,
      ClientsComponent,
      PersonsComponent,
      AgentDashboardComponent,
      AgentSpamQueueComponent,
      UserProfileComponent,
      LoginFormComponent,
      // ToolbarComponent,
      SideMenuComponent,
      GlobalSettingsComponent,
      CurrencyselectorComponent,
      CompanyselectorComponent,
      PersonselectorComponent,
      DocumentselectorComponent,
      PipeselecteditemsPipe,
      SetupComponent,
      DepartmentselectorComponent,
      EditCurrencyDlgComponent,
      AgentBankPaymentReviewComponent,
      AgentBankPaymentSplitComponent,
      DocumentPreflightComponent,
      DocumentPreflightSummaryComponent,
      CurrencyRatesComponent,
      EditDocumentComponent,
      DocumentsTreeComponent,
      ProductsComponent,
      EditProductComponent,
      SalesLeadsComponent,
      PipeselecteditemsPipe,
      PipeTrimStr,
      TabTitleDirective,
      ProdgroupselectorComponent,
      ProductselectorComponent,
      DocumentsSearchComponent,
      ProductsSearchComponent,
      ClientsSearchComponent,
      ProdgroupSearchComponent,
      EditClientComponent,
      CustomercategoryselectorComponent,
      EditUserAccessComponent,
      AgentSetupComponent,
      HiddenDocumentsComponent,
      EditVariableComponent,
      DocumentContentTableComponent,
      ItemTurnoverSheetComponent,
      TurnoverSheetTableComponent,
      ProductListComponent,
      ProdGroupTreeComponent,
      Products2Component,
      ProductInfoComponent,
      VariableSelectorComponent,
      VariableEditComponent,
      EditProductVendorsComponent,
      EditProductPartsComponent,
      SecurityGroupSelectorComponent,
      CreateNewDocumentComponent,
      ConfirmDeleteProductPartComponent,
      EditDocumentContentComponent,
      DocumentTransactionTableComponent,
      DocumentSalesResultTableComponent,
      ProductListPaidComponent,
      ProductListInvoicedComponent,
      ProductReservationTableComponent,
      ExportDocumentComponent,
      ProductPriceHistoryComponent,
      CompanySearchComponent,
      NewDocumentDlgDatesComponent,
      NewDocumentDlgCompaniesComponent,
      NewDocumentDlgConditionsComponent,
      NewDocumentDlgProcessPaymentComponent,
      NewDocumentDlgDocItemsComponent,
      NewDocumentDlgAiAssistComponent,
      EditDocumentCompanyComponent,
      EditDocumentClientComponent,
      EditDocumentConditionsComponent,
      NewDocumentDlgProcessInvoiceComponent,
      RenameSomethingDialogComponent,
      ListClientPersonsComponent,
      ListClientLcosComponent,
      EditClientDepartmentsComponent,
      EditPersonComponent,
      ImportExcelDlgComponent,
      ListDocItemsComponent,
      ReportProductTosComponent,
      EditDocumentPoComponent,
      EditDocumentSpecComponent,
      EditDocumentContentSpecComponent,
      EditDocumentContentPoComponent,
      NewDocumentDlgProcessPoComponent,
      EditPrintReportsComponent,
      ProductListInTransitComponent,
      EditDocumentReceiptComponent,
      EditDocumentContentReceiptComponent,
      EditDocumentConditionsReceiptComponent,
      NewDocumentDlgProcessReceiptComponent,
      NewDocumentDlgProcessShipmentComponent,
      NewDocumentDlgCompaniesReceiptComponent,
      NewDocumentDlgConditionsReceiptComponent,
      NewDocumentDlgProcessSpecComponent,
      NewDocumentDlgProcessTransactionComponent,
      HomeRecentOrdersListComponent,
      DocumentListTableComponent,
      HomePaidOrdersListComponent,
      HomeNotShippedOrdersListComponent,
      HomeNotPaidOrdersListComponent,
      HomeActiveOrdersListComponent,
      HomeChartCurrencyRatesComponent,
      HomeChartAnnualSalesComponent,
      HomeChartPerformanceSalesComponent,
      NewDocumentDlgProcessTranImpComponent,
      NewDocumentDlgProcessTranProdComponent,
      NewDocumentDlgProcessTranMoveComponent,
      NewDocumentDlgProcessTranSaleComponent,
      EditDocumentContentPaymentComponent,
      ProductListStocksComponent,
      EditSalesLeadComponent,
      ListSalesLeadItemsComponent,
      EditSalesLeadItemsComponent,
      ProductPartListPaidComponent,
      ListManufacturingStatusComponent,
      EditDocumentRowInfoComponent,
      ProductPartListByDocComponent,
      EditDocumentInventoryComponent,
      EditDocumentContentInventoryComponent,
      EditDocumentCompanyInventoryComponent,
      EditDocumentClientInventoryComponent,
      NewDocumentDlgCompaniesInventoryComponent,
      NewDocumentDlgClientInventoryComponent,
      EditDocTypeItemComponent,
      EditDocTypesComponent,
      CreatePriceListComponent,
      ListProductArrayComponent,
      ListDocumentPaymentsComponent,
      ImportProductInfoDlgComponent,
      ListCurrencyRatesComponent,
      UpdateCurrencyByExternalApiComponent,
      CompanyRegisterVerifyComponent,
      CompanyDirectorQuickSetComponent,
      AgentCustomerQuickCreateComponent,
      AgentCustomerUpdateOfferComponent,
      AgentPasteToCreateComponent,
      CustomerBusinessAreaSelectorComponent,
      ProductGlobalCategorySelectorComponent,
      ListClientBalanceDueComponent,
      ListDocumentsForClientComponent,
      ListDocumentsForProductComponent,
      ProductSerialsTableComponent,
      ListProductsParentComponent,
      SelectProductCategoryComponent,
      ListDocumentWarningsComponent,
      KeycloakuserselectorComponent,
      NewDocumentDlgProcessTranInterComponent,
      CopyDepartmentsComponent,
      ShowDepartmentNameComponent,
      EditUserAccessTabComponent,
      EditAccessGroupsTabComponent ,
      ListProductsOfCustomerComponent,
      ListProductsCustomersTransactionsComponent,
      HomeChartDailyPaymentsComponent,
      HomeChartMonthlyPaymentsComponent,
      HomeChartMonthlyClientPaymentsComponent,
      EditAgentTeamMembersTabComponent,
      EditAgentBankCredentialsTabComponent,
      EditAgentBankBlockedCounterpartiesTabComponent,
      EditAgentCustomerTierTabComponent,
      EditAgentCustomerTierListTabComponent,
      EditPriceVariablesTabComponent,
      StopAccordionHomeEndDirective,
      IncomePriceBreakdownDialogComponent,
      ManufacturingBackdocPriceCheckDialogComponent,
    ],

    imports: [
      BrowserModule,

      // Import the module into the application, with configuration
      // AuthModule.forRoot({ ...env.auth }),

      KeycloakAngularModule,

      BrowserAnimationsModule,
      HttpClientModule,
      AppRoutingModule,
      MatToolbarModule,
      MatSidenavModule,
      MatListModule,
      MatButtonModule,
      MatIconModule,
      TableModule,
      ToastModule,
      ToolbarModule,
      ButtonModule,
      PanelModule,
      CardModule,
      MultiSelectModule,
      ListboxModule,
      TabViewModule,
      DialogModule,
      ConfirmDialogModule,
      InputTextModule,
      InputMaskModule,
      CheckboxModule,
      RadioButtonModule,
      InputTextareaModule,
      InputNumberModule,
      DropdownModule,
      FormsModule,
      AccordionModule,
      CalendarModule,
      ContextMenuModule,
      ProgressBarModule,
      ChartModule,
      SliderModule,
      TreeModule,
      TooltipModule,
      RippleModule,
      SplitterModule,
      OverlayPanelModule,
      ProgressSpinnerModule,
      SelectButtonModule,
      TagModule,
      AutoCompleteModule,
      SplitButtonModule,
      FieldsetModule,
      InputSwitchModule,
      EditorModule,
      FileUploadModule,
      BlockUIModule,
      AppLayoutModule,
      ClipboardModule,
      MenubarModule,
      TabMenuModule,
      ScrollTopModule,
      ],

  // https://www.tektutorialshub.com/angular/angular-how-to-use-app-initializer/

  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initialConfigurationLoad,
      multi: true,
      deps: [GetglobalsettingsService, AppConfigService, KeycloakService],
    },

    AuthGuard,
    PendingChangesGuard,
    SecureApiService,
    RestApiService,
    MessageService,
    ConfirmationService,
    Title,
    DocumentApiService,
    ClientApiService,
    ProductApiService,
    HelperServerApiServiceService,    
    {
      provide: LOCALE_ID,
      useValue: 'uk'
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

